import React from 'react';
import {MyDemandContent} from './my-demand-content';
import {UserLayout} from 'components/layouts/user';

class MyDemandContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="my-posted-demands">
        <h1 className="user-header">Nhu cầu đã đăng</h1>
        <MyDemandContent/>
      </UserLayout>
    );
  }
}

export default MyDemandContainer;



// WEBPACK FOOTER //
// ./components/users/MyDemandContainer.jsx